import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { bool, element, func, node, oneOf, oneOfType, string } from 'prop-types';
import { menuItemsPropType } from "../Menu/propTypes";
import { VARIANT } from "./constants";
var variant = oneOf(Object.keys(VARIANT));
export var cardPropTypes = {
  children: node.isRequired,
  onClick: func
};
export var cardActionsPropTypes = {
  children: node.isRequired
};
export var cardBlockPropTypes = {
  children: node.isRequired
};
export var cardDividerPropTypes = {};
export var cardFooterPropTypes = {
  children: node,
  defaultIsOpen: bool,
  expandable: bool,
  isOpen: bool,
  onClose: func,
  onOpen: func,
  title: oneOfType([string, element]),
  triggerTitle: func,
  variant: variant
};
export var cardImagePropTypes = {};
export var cardStatusPropTypes = {
  children: string.isRequired,
  variant: variant
};
export var cardTitlePropTypes = {
  actions: node,
  avatar: oneOfType([string, element]),
  children: node.isRequired,
  secondaryText: oneOfType([string, element]),
  subtitle: node,
  variant: variant
};
export var cardTitleMenuPropTypes = {
  data: menuItemsPropType.isRequired,
  triggerTitle: string
};